import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Heart, Wine, Users, CheckCircle } from 'lucide-react';

const PACKAGES = [
  {
    name: 'Intimate Celebration',
    bottles: '30-60',
    description: 'Perfect for smaller weddings and intimate gatherings',
    features: [
      '30-60 custom-labeled bottles',
      'Choice of red or white wine',
      'FREE Wedding Planner PDF',
      'Personalized labels with your names & date',
      'Foil tops included',
      'Bottling party option',
    ],
    Icon: Heart,
  },
  {
    name: 'Classic Wedding',
    bottles: '60-120',
    description: 'Our most popular package for traditional weddings',
    features: [
      '60-120 custom-labeled bottles',
      'Mix of red and white wines',
      'FREE Wedding Planner PDF',
      'Premium label design',
      'Complimentary tasting session',
      'Foil tops & gift packaging',
      'Fun bottling experience for wedding party',
    ],
    Icon: Wine,
    popular: true,
  },
  {
    name: 'Grand Celebration',
    bottles: '120+',
    description: 'For large celebrations and receptions',
    features: [
      '120+ custom-labeled bottles',
      'Premium wine selection',
      'FREE Wedding Planner PDF',
      'Custom label artwork',
      'Private tasting for couple',
      'VIP bottling experience',
      'Delivery available',
      'Dedicated wedding coordinator',
    ],
    Icon: Users,
  },
];

const scrollToForm = () => {
  document.getElementById('booking-form')?.scrollIntoView({ behavior: 'smooth' });
};

const WeddingsPackages = () => (
  <section className="py-16 bg-gray-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Our Wedding Packages</h2>
      <div className="grid md:grid-cols-3 gap-8">
        {PACKAGES.map((pkg) => (
          <Card
            key={pkg.name}
            className={`relative hover:shadow-xl transition-shadow ${pkg.popular ? 'border-2 border-[#FDB913]' : ''}`}
          >
            {pkg.popular && (
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-[#FDB913] text-gray-900 px-4 py-1 rounded-full text-sm font-semibold">
                  Most Popular
                </span>
              </div>
            )}
            <CardContent className="pt-8 pb-8">
              <div className="text-center mb-6">
                <div className="text-[#FDB913] mb-4 flex justify-center">
                  <pkg.Icon className="w-12 h-12" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                <p className="text-[#FDB913] font-semibold text-lg mb-2">{pkg.bottles} bottles</p>
                <p className="text-gray-600 text-sm">{pkg.description}</p>
              </div>
              <ul className="space-y-3 mb-6">
                {pkg.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2 text-sm">
                    <CheckCircle className="w-5 h-5 text-[#FDB913] flex-shrink-0 mt-0.5" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              <Button
                className="w-full bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-semibold"
                onClick={scrollToForm}
                data-track="weddings:wedding_package_book"
              >
                Book This Package
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

export default WeddingsPackages;
